import styled from "styled-components";
import { ButtonSettings, Text, Heading } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    margin-top: ${props.theme.spacing.medium};
    width: 35rem;
  `}
`;

export const LogoStyled = styled.div`
    position: absolute;
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.spacing.large};
    top: 4.5rem;
}
`;

export const LandingPageStyled = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  padding: 0 3rem;
`;

export const TextContainer = styled.div`
  width: 77%;
  margin: 0 auto;
`;

export const TextStyled = styled(Text)`
  font-weight: normal;
  font-size: 1.125rem;
  margin-top: 1rem;
  color: #d1d3d4;
`;

export const BuyAssetContainer = styled.div`
  display: flex;
  padding-top: 8rem;
  justify-content: space-between;
`;
export const FirstContainerStyle = styled.div`
  display: block;
  width: 31%;
  //  padding-left: 2rem;
`;
export const ImageStyle = styled.div`
  height: 12.577rem;
  width: 22.36rem;
  border-radius: 0.5rem;
  margin: 0 auto;
`;

export const DetailsContainerStyle = styled.div`
  width: 45%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  padding: 1rem;
`;

export const HeadingStyle = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
`;

export const HeadingContentStyled = styled(Heading)`
  font-size: 3rem !important;
  font-weight: bold !important;
  width: 60%;
`;
export const PriceStyled = styled(Heading)`
  font-size: 3rem !important;
  font-weight: bold !important;
`;

export const TextDetailsStyled = styled(Text)`
  font-size: 1.75rem;
  padding-top: 2rem;
  margin-bottom: 1.8rem;
`;

export const StepContainer = styled.span`
  vertical-align: middle;
  width: 100%;
  margin-bottom: ${props => (props.userLocale === "ar" ? "0px" : props.theme.spacing.xsmall)};
  display: block;
  margin-bottom: 1.8rem;
`;

export const StepNumber = styled.div`
  border-radius: 50%;
  display: inline-block;
  width: calc(4.125rem);
  height: calc(4.125rem);
  padding: ${props => props.theme.spacing.default} ${props => props.theme.spacing.xsmall};
  border: 3px solid rgba(${props => props.theme.color.primaryRGB}, 0.4);
  color: ${props => props.theme.color.white};
  text-align: center;
  font-size: ${props => props.theme.font.size.large};
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 0.8rem;
`;

export const StepText = styled(Text)`
  vertical-align: middle;
  font-weight: normal;
  display: inline-block;
  margin-bottom: ${props => props.theme.spacing.small};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  ${props => props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT && `width: 80%`}; /* only for ps4 */
`;

export const QRCodeWrapper = styled.div`
  width: 20vw;
  height: 20vw;
  border: 1.25rem solid #fff;
  border-radius: ${props => props.theme.spacing.small};
  margin-top: 13rem;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ButtonModelWrapper = styled.div`
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")};
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  // display: block;
  // margin-top: ${props => props.theme.spacing.xsmall};
  width: 20.5%;
  // margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right: 72rem" : "left: 72rem")};
  top: calc(-0.5rem * 3);
  position: relative;
`;
